import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/svg/LogoNetuno.svg'
import './Error.css'

const Error404 = () => {
    return (
        <div id="notfound">
            <div className="notfound">
                <div className="notfound-404">
                    <h1>404</h1>
                </div>
                <div style={{ display: 'flex' }}>
                    <img style={{ width: '100%', }} src={logo} />
                </div>
                <h2>LO SENTIMOS, ¡PÁGINA NO ENCONTRADA!</h2>
                <p>LA PÁGINA QUE ESTÁ BUSCANDO PODRÍA HABERSE ELIMINADO POR CAMBIO DE NOMBRE O NO ESTÁ DISPONIBLE TEMPORALMENTE.</p>
                <div className='flex justify-center items-center' >
                    <Link to='/cuenta/dashboard'>Volver a la página de inicio</Link>
                </div>

            </div>
        </div>
    )
}

export default Error404
